import BaseResource from './BaseResource'

export default class DeviceControllers extends BaseResource {
  static endpoint = '/api/v1/deviceControllers' // /edge
}
